import { createSlice } from "@reduxjs/toolkit";
import { LayoutStateProps } from "../../../Types/Layout.type";


const userId=JSON.parse(String(localStorage.getItem("user")))?.id;
const userRole=JSON.parse(String(localStorage.getItem("user")))?.role;
// alert("userRole in LayoutReducer:"+userRole);

// console.log("userId in LayoutReducer:",typeof(userId));
// alert((localStorage.getItem("app_tour_shown_v1") != "true")&&(userId!=undefined))

const initialState: LayoutStateProps = {
    responsiveSearch: false,
    pinedMenu: [],
    sideBarToggle: false,
    isSearchBarOpen: false,
    showTourModel: (localStorage.getItem("app_tour_shown_v1") != "true")&&(userId!=undefined)&&(userRole!="admin"),
};

const LayoutSlice = createSlice({
    name: "layout",
    initialState,
    reducers: {
        setIsSearchBarOpen: (state, action) => {
            state.isSearchBarOpen = action.payload;
        },
        setResponsiveSearch: (state) => {
            state.responsiveSearch = !state.responsiveSearch;
        },
        setPinedMenu: (state, action) => {
            state.pinedMenu = action.payload;
        },
        setSideBarToggle: (state, action) => {
            state.sideBarToggle = action.payload;
        },
        handlePined: (state, action) => {
            if (action.payload) {
                if (state.pinedMenu.includes(action.payload)) {
                    let filterMenu = state.pinedMenu.filter((item) => item !== action.payload);
                    state.pinedMenu = filterMenu;
                } else {
                    state.pinedMenu = [...state.pinedMenu, action.payload];
                }
            }
        },
        setShowTourModel: (state, action) => {
            state.showTourModel = action.payload;
        }
    },
});
export const { setResponsiveSearch,setIsSearchBarOpen, setPinedMenu, setSideBarToggle, handlePined,setShowTourModel } = LayoutSlice.actions;
export default LayoutSlice.reducer;
